export const productKeyMap = {
    "餐點 ID": "id",
    "名稱": "name",
    "允許販售": "availableInStore",
    "價格": "standardPrice",
    "VIP價格": "vipPrice",
    "成本": "cost",
    "是否現場定價": "isDynamicPrice",
    "是否為免稅商品": "isTaxFree",
    "庫存量上限": "stockLimit",
    "庫存模式": "stockMode",
    "自動補貨數量": "autoReplenishCount",
    "商品簡介": "description",
    "國際條碼": "internationalCode",
    "SKU編碼": "skuCode",
    "背景顏色 (hex code RRGGBB)": "backgroundColor",
    "規格 ID": "subSpecID",
    "必選": "mustHave",
    "前台顯示名稱": "frontEndDisplayName",
    "單選": "isSingleSelection",
    "多選最少": "multiSelectionMin",
    "多選最多": "multiSelectionMax",
    "可重複選": "allowSelectManyTimes"
}

export const comboKeyMap = {
    "套餐 ID": "id",
    "名稱": "name",
    "允許販售": "availableInStore",
    "價格": "standardPrice",
    "VIP價格": "vipPrice",
    "成本": "cost",
    "是否現場定價": "isDynamicPrice",
    "是否為免稅商品": "isTaxFree",
    "庫存量上限": "stockLimit",
    "每日自動補貨": "dailyAutoReplenish",
    "無限制庫存": "unlimitedStock",
    "商品簡介": "description",
    "國際條碼": "internationalCode",
    "SKU編碼": "skuCode",
    "背景顏色 (hex code RRGGBB)": "backgroundColor",
    "套餐模式": "comboMode",
    "餐點 ID": "id",
    "套餐子項 ID": "subSpecID",
    "必選": "mustHave",
    "前台顯示名稱": "frontEndDisplayName",
    "單選": "isSingleSelection",
    "多選最少": "multiSelectionMin",
    "多選最多": "multiSelectionMax",
    "可重複選": "allowSelectManyTimes",
    "任選子項 ID": "comboSubAnyID",
    "可選數量": "selectionCount"
}
export const specificationKeyMap = {
    "規格 ID": "id",
    "名稱": "name",
    "「一般規格」啟用中": "enableForProductComboSpec",
    "「全單規格」啟用中": "enableForOrderSpec",
    "標籤機列印名稱": "stickerTagPrintName",
    "價格": "price",
    "無限制庫存": "unLimitStock",
    "庫存上限": "stockLimit",
    "每日自動補貨": "dailyAutoRestock"
}

export const comboSubItemsKeyMap = {
    "套餐子項 ID": "id",
    "名稱": "name",
    "前台顯示名稱": "frontEndDisplayName",
    "啟用": "enable",
    "替換子項 ID": "comboSubAltID",
    "替換基價": "altBasePrice"
}

export const comboSubAnyKeyMap = {
    "任選子項 ID": "comboSubAnyID",
    "名稱": "name",
    "啟用": "enable",
    "餐點 ID": "id",
}

export const comboSubAltKeyMap = {
    "套餐子項 ID": "id",
    "名稱": "name",
    "啟用": "enable",
    // "餐點 ID": "id",
}

export  const productComboSpecKeyMap = {
    "規格 ID": "id",
    "必選": "mustHave",
    "前台顯示名稱": "frontEndDisplayName",
    "單選": "isSingleSelection",
    "多選最少": "multiSelectionMin",
    "多選最多": "multiSelectionMax",
    "可重複選": "allowSelectManyTimes"
}